import React from "react";
export default () => (
  <div className="mt-5 text-right flex justify-around flex-row">
    <div className="flex flex-col">
      <div className="App-Logo flex justify-end ">
        <img class="scale-1 h-24" src="./logo.png" alt="fomo-score.com" />
      </div>
    </div>
    <div className="flex justify-center flex-col align-right gap-3">
      <a
        href="https://apps.apple.com/us/app/fomo-score/id6446705709"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img className="scale-1 h-10" alt="app store" src="./apple-badge.png" />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.fomoscore.app"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className="scale-1 h-10"
          alt="google play"
          src="./google-badge.png"
        />
      </a>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/footer.js